const moveH1 = () => {
  var bannerImage = document.querySelector('.banner-image');
  var h1 = document.querySelector('h1');
  if (bannerImage !== null) {
    bannerImage.appendChild(h1);
  }
  if (h1 !== null) {
    h1.style.visibility = 'visible';
  }

  document.querySelector('.main').style.opacity = 1;
  if (document.querySelector('.landing-page') !== null) {
    document.querySelector('body').classList.add('custom-landing-page');
  }
};

export { moveH1 };



// WEBPACK FOOTER //
// ./partial-scripts/moveH1.js